<template>
    <div class="row no-gutters flex-fill panel-audit">
        <div class="col-12">
            <component
                :is="viewer"
                :panelId="idPanel"
                :translatePrefix="translatePrefix"
                :url="url"
            />
        </div>
    </div>
</template>

<script>
import { toCamelCase } from '@config/utils';

export default {
	name: 'PanelAudit',
    components: {
        CardAudit: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "audit-card" */ './components/CardAudit'),
        TableAudit: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "audit-table" */ './components/TableAudit'),
    },
	props: {
        translatePrefix: {
			type: String,
			default: null,
		},
        url: {
			type: String,
			require: true,
		},
        appresentation: {
            type: String,
            default: 'table',
            validator: function (prop) {
                let valid = [
                    'table',
                    'card',
                ];
                return valid.includes(prop);
            }
        },
	},
	data() {
		return {
			idPanel: 'audits',
		}
	},
	computed: {
        viewer() {
            return `${toCamelCase(this.appresentation, true)}Audit`;
        },
	},
	methods: {

	},
	watch: {

	}
}
</script>

<style scoped lang="scss">
</style>